import React from "react";
import { RaiseColors } from "componentLibrary";
import { jsx as _jsx } from "react/jsx-runtime";
var BuildingFallbackImage = function BuildingFallbackImage(_ref) {
  var width = _ref.width,
    height = _ref.height,
    _ref$borderRadius = _ref.borderRadius,
    borderRadius = _ref$borderRadius === void 0 ? 4 : _ref$borderRadius,
    _ref$opacity = _ref.opacity,
    opacity = _ref$opacity === void 0 ? 1 : _ref$opacity;
  return /*#__PURE__*/_jsx("div", {
    className: "fa-kit fa-city-two",
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minWidth: width,
      width: width,
      height: height,
      borderRadius: borderRadius,
      backgroundColor: RaiseColors.pastelPurple,
      color: RaiseColors.midnight,
      opacity: opacity
    }
  });
};
export default BuildingFallbackImage;